var _style, _defs, _defs2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 437.9 614.3",
    style: {
      enableBackground: "new 0 0 437.9 614.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:4.000000e-02;}\r\n\t.st1{fill:#1A1A1A;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M401.9,190.3c-2.1-35,29.2-47,29.2-47L409.9,95c0,0-29.6,18.1-54.9-8.6c-20.8-21.9-6.8-54.4-6.8-54.4 L300.9,8.6c0,0-8,31.3-46.4,29.7C208.6,36.3,213.2,0,213.2,0l-51.3,12.5c0,0,20.7,27.9-15.6,53c-37.6,25.9-57.2-3.1-57.2-3.1 l-31.3,42.5c0,0,35.3,8.8,23.1,52.3c-12.4,43.9-46.8,32.6-46.8,32.6l3.4,52.7c0,0,33.4-13.7,50.1,24.6c8.4,19.4,36.2,7,28.6-11.2 c-16.3-39-14.6-84.9,9.6-123.4C164.9,70.3,247,51.6,309.3,90.8c62.2,39.1,80.9,121.2,41.8,183.4c-18.6,29.6-46.8,50.4-78.4,57.7 c-20.2,4.7-11.6,33.7,4.8,29.1c39-10.8,50.4,21.9,50.4,21.9l44-29.3c0,0-23.6-28.4,1.4-58.6c20.8-25.2,49.9-13.1,49.9-13.1 l14.8-50.7C437.9,231.2,403.9,223.7,401.9,190.3z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#1A1A1A"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160870229607462361460000010104459795648097169_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013175489050788902530000018022146276634722944_",
    d: "M331.3,180c-4.4-15.4-12.2-28.8-22.1-40.1l-47.6,85.2 c-2.4,4.5-5.9,8.2-9.7,10.8c-3.6,2.6-7.7,4.5-11.9,5.7l17.4,67.1c0.9-0.2,1.7-0.4,2.6-0.7l6.5-2.5 C317.4,287.1,346.3,232.8,331.3,180z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013175489050788902530000018022146276634722944_",
    style: {
      overflow: "visible",
      fill: "#1A1A1A"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096750745945008192890000005649826387641159851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013175489050788902530000018022146276634722944_",
    style: {
      overflow: "visible"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.5,242.8c-9.1-5.1-15.5-11.1-18.2-23c-1-4.5-1.6-8.9-1.1-13.3c0.5-5.3,1.6-10.6,4.5-15.4l51.8-93 c-16.2-2.9-33.1-2.5-49.8,2.3c-57.9,16.4-91.7,74.8-79.5,132.5l1.4,7.6c3.8,13.3,10.2,25.1,17.8,35.6L5.8,544.6l-0.6,1.3 c-11.5,22.5-3.2,50.3,19.2,62.6c22.3,12.3,50.2,4.5,63.1-17.3l0.8-1.3l154.6-280L227.5,242.8z M179.7,346L55.9,574.5 c-2.8,5.1-9.2,7-14.4,4.2c-5.1-2.8-7-9.2-4.2-14.4l123.8-228.4c2.8-5.1,9.2-7,14.4-4.2C180.7,334.5,182.5,340.9,179.7,346z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.3f1e23cbeb70c5f11d13ca0dca889313.svg";
export { ForwardRef as ReactComponent };